
/* injects from baggage-loader */

import React from 'react';
import { t } from '../../../../helpers/translator';
import moment from "moment";
import PropTypes from 'prop-types';

class VirtualsResult extends React.Component {
    render () {
        const { sportComps, filteredData, isFiltred } = this.props;
        return (
            <div>
                {
                    sportComps && sportComps.length > 0
                        ? <div className="container-info">
                            <div className="container-info-header">
                                <div className="title-bg">
                                    <div className="inner-info-header">
                                        <div>{t(`DATE`)}</div>
                                        <div>{t(`ID `)}</div>
                                        <div>{t(`SPORT`)}</div>
                                        <div>{t(`MATCH NAME`)}</div>
                                        <div>{t(`COMPETITION`)}</div>
                                        <div>{t(`REGION`)}</div>
                                    </div>
                                </div>
                            </div>
                            {
                                !isFiltred
                                    ? sportComps.map((item) => {
                                        var regMatching = item.scores && item.scores.match(/\d\s[a-zA-Z0-9]+/g);
                                        // eslint-disable-next-line react/jsx-key
                                        return <div className="match-info" key={item.game_id}>
                                            <div className="inner-match-info open-info" >
                                                <div className="match-row">
                                                    <div className="item-match">{moment.unix(item.date).format('lll')}</div>
                                                    <div className="item-match">{item.short_id}</div>
                                                    <div className="item-match">{item.sport_name}</div>
                                                    <div className="item-match">{item.competition_name}</div>
                                                    <div className="item-match">{item.competition_name}</div>
                                                    <div className="item-match">{item.region_name}
                                                    </div>
                                                </div>
                                                <div className="virtual-row">
                                                    <div className="virtual-teams">
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[0]}</div>
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[1]}</div>
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[2]}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>;
                                    })
                                    : filteredData && isFiltred && filteredData.map((item) => {
                                        var regMatching = item.scores && item.scores.match(/\d\s[a-zA-Z0-9]+/g);
                                        // eslint-disable-next-line react/jsx-key
                                        return <div className="match-info" key={item.game_id}>
                                            <div className="inner-match-info open-info" >
                                                <div className="match-row">
                                                    <div className="item-match">{moment.unix(item.date).format('lll')}</div>
                                                    <div className="item-match">{item.short_id}</div>
                                                    <div className="item-match">{item.sport_name}</div>
                                                    <div className="item-match">{item.competition_name}</div>
                                                    <div className="item-match">{item.competition_name}</div>
                                                    <div className="item-match">{item.region_name}
                                                    </div>
                                                </div>
                                                <div className="virtual-row">
                                                    <div className="virtual-teams">
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[0]}</div>
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[1]}</div>
                                                        <div>{regMatching && regMatching.length > 0 && regMatching[2]}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>;
                                    })
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}
VirtualsResult.propTypes = {
    sportComps: PropTypes.array,
    filteredData: PropTypes.array,
    isFiltred: PropTypes.bool
};
export default VirtualsResult;